/** @format */
import { useContext, useMemo } from 'react';

import { getConfig } from '@toucan/common/services/nextjs/settings';

import { MarketContext } from '@toucan/client/global/market';

import { cloudflareLoader } from './cloudflare-loader';
import { contentfulLoader } from './contentful-loader';
import { ResponsiveLoader, ResponsiveLoaderType } from './types';

export { getCloudflareResizeServiceUrl } from './cloudflare-loader';
export { ResponsiveLoaderType } from './types';

export const useResponsiveLoader = (
    loaderType?: ResponsiveLoaderType
): ResponsiveLoader => {
    const { activeMarket } = useContext(MarketContext);
    const { publicRuntimeConfig } = getConfig();

    return useMemo(() => {
        switch (loaderType) {
            case ResponsiveLoaderType.CLOUDFLARE: {
                const isResizeEnabled = Boolean(
                    publicRuntimeConfig?.cloudflareImageResizeEnabled
                );

                if (isResizeEnabled) {
                    return {
                        loader: cloudflareLoader,
                        isLoaderEnabled: true,
                    };
                }

                return { loader: undefined, isLoaderEnabled: false };
            }
            case ResponsiveLoaderType.CONTENTFUL:
                return { loader: contentfulLoader, isLoaderEnabled: true };
            default:
                // Use built-in loader
                return { loader: undefined, isLoaderEnabled: true };
        }
    }, [
        loaderType,
        activeMarket?.code,
        publicRuntimeConfig?.cloudflareImageResizeEnabled,
    ]);
};
